<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="ack"><a id="page_xii"></a><a id="page_xiii"></a><a href="#/xhtml/contents#ack">Acknowledgments</a></p>
<p class="Bodyflush">Many thanks are due those who read bits and pieces of early versions: Judson Bliss, Anne Carman, Sharon Lindsay, Caroline Ratcliffe, and Aspen Scafa. Special thanks to Taylor Lindsay for her encouragement and comments on early drafts, but especially for gifting me with the arresting phrase “It’s a ritual-eat-ritual world.” This book springs from research I completed because of a generous grant from the John Templeton Foundation through Yoram Hazony and The Herzl Institute in 2013. Yoram’s friendship has meant the world to me.</p>
<p class="Body">I wouldn’t want to function in this world without Stephanie Johnson and our children: Claudia, Benjamin, Olivia, and Luisa (in no particular order). Equally, the academic world would suck the life out of me without colleagues such as Josh Blander, Anthony Bradley, Eric Bennett, Ryan O’Dowd, Jonathan Pennington, Michael Rhodes, Jennifer Tharp, Gregory Thornbury, and just about everyone at The King’s College, <i>especially my students</i> (not to mention regular help from Kimberly Thornbury, Rebecca Au-Mullaney, and Natalie Nakamura). Thank you to our crew at Pennington Court and Comunidade Cristã Presbiteriana church in Newark, New Jersey, for helping our family to practice the good news. (Looking at you, Kezia Paschoal!)</p>
<p class="Body"><a id="page_xiv">I wouldn’t have had the courage to write this book without the editorial coaching of Lil Copan, who made it happen. Brutal honesty is my love language, and Lil is fluent. And I would be even more embarrassed about the writing within it apart from the editorial savvy of Mary Hietbrink. <i>Nota bene</i>: So many of these thoughts merely wax <i>ritual-ly</i> on what I have learned from Esther Meek over the last two decades.</a></p><a id="page_xiv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?a43419fc